export enum BaseIngredientSortOrder {
	NameAsc = 'NameAsc',
	NameDesc = 'NameDesc',
	LastEditedDateAsc = 'LastEditedDateAsc',
	LastEditedDateDesc = 'LastEditedDateDesc',
	DensityAsc = 'DensityAsc',
	DensityDesc = 'DensityDesc',
	CaloriesAsc = 'CaloriesAsc',
	CaloriesDesc = 'CaloriesDesc',
	CarbonDioxideAsc = 'CarbonDioxideAsc',
	CarbonDioxideDesc = 'CarbonDioxideDesc',
	Relevance = 'Relevance',
}
